import { ref } from "vue";
import { CustomerModel } from '@/models/CustomerModel'

export const customer = ref<any>(JSON.parse(localStorage.getItem('customer') as string) ? JSON.parse(localStorage.getItem('customer') as string) : {})
export const isAuthModalOpen = ref<boolean>(false)